import { VkEmailPage } from '@/app/pages/auth/vk/vk-email-page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/auth/vk-email')({
  component: VkEmailPage,
});
